import React, { useState } from 'react'
import { createTheme } from '@material-ui/core/styles'
import styled from 'styled-components'
import Axios from 'axios'
import AlertMessage from 'src/components/Global/Alert/AlertMessage'
import { CollaboTypes } from 'src/redux/types/collaboTypes'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'
import { makeStyles } from '@mui/styles'

const Wrapper = styled.div`
  .upload {
    position: relative;
    margin: auto;
  }
  .download-box {
    font-size: ${({ theme }) => theme.fontSize.x5};
    color: ${({ theme }) => theme.colors.gray};
    opacity: 0.8;
    margin-top: 20px;
    height: 170px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: transparent;
    border: 1px solid #858c94;
    cursor: pointer;
  }
  img {
    max-width: 100% !important;
    height: auto;
  }

  .item {
    width: 100%;
    max-height: auto;
    float: left;
    padding: 3px;
    .profileImage {
      margin-top: 40px;
      width: 419px;
      margin-left: 40px;
      height: 419px;
    }
  }

  .upload img {
    border: 6px solid #eaeaea;
  }
  .width {
    width: 15%;
    position: absolute;
    right: 0px;
    bottom: 0px;
  }
  .upload-photo {
  }
  .upload .round {
    position: absolute;
    top: 40px;
    background: transparent;
    width: 50%;
    height: 90px;
    text-align: center;
  }

  .upload .round input[type='file'] {
    position: absolute;
    transform: scale(2);
    opacity: 0;
    width: 100%;
    z-index: 10000;
    height: 100px;
    top: 45px;
  }

  input[type='file']::-webkit-file-upload-button {
    cursor: pointer;
    width: 100%;
    height: 190px;
    border: 2px solid red;
  }
`
const theme = createTheme({
  spacing: 4,
})

const useStyles = makeStyles({
  root: {
    background: '#FAF3EC',
    width: 'auto',
    position: 'absolute',
    top: 'calc(50% - 240px)',
    left: 'calc(40% - 160px)',
  },
  formImage: {
    boxShadow: '0 0 10px',
    backgroundColor: 'white',
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '25ch',
  },
  divForm: {
    width: '90%',
  },
  image: {
    width: '90%',
    height: '35%',
    margin: '8px',
  },
  paperRoot: {
    maxWidth: 345,
  },
})
const CLOUDINARY_NAME = 'fandksavings'
const CLOUDINARY_UPLOAD_PRESET = 'fkdobyd1'
const cloudinary_url = `https://api.cloudinary.com/v1_1/${CLOUDINARY_NAME}/image/upload`
const CollaboUpload = () => {
  const classes = useStyles()
  const [file, setFile] = useState('')
  const [collaboData, setCollaboData] = useState({
    image: '',
  })
  const { image } = collaboData

  const [showAlert, setShowAlert] = useState(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [alertMessage, setAlertMessage] = useState({
    type: '',
    message: '',
  })
  const dispatch = useDispatch()
  let newData: any
  const getCloudinaryLink = (item: any, callback: any) => {
    Axios.post(cloudinary_url, item).then((response) => {
      newData = response.data.url
      callback()
    })
  }
  function handleChange(e: any) {
    let url = URL.createObjectURL(e.target.files[0])
    setFile(url)
    const data = new FormData()
    data.append('file', e.target.files[0])
    data.append('upload_preset', CLOUDINARY_UPLOAD_PRESET)
    getCloudinaryLink(data, function () {
      setTimeout(() => {}, 3000)
      collaboData.image = newData
      dispatch(action(CollaboTypes.COLLABO_FORM_DATA, collaboData))
    })
  }

  return (
    <Wrapper>
      <div className="upload">
        <div className="item">
          {file.length > 0 ? (
            <img src={file} alt="" className="download-box" />
          ) : (
            <div className="download-box">Upload Group Image</div>
          )}
        </div>
        <div className="round">
          <div className={classes.divForm}>
            <input type="file" onChange={handleChange} name="upload-photo" />
          </div>
        </div>
        <AlertMessage severity="warning" message={alertMessage.message} />
        <AlertMessage
          open={showAlert}
          setOpen={setShowAlert}
          type={alertMessage.type}
          message={alertMessage.message}
        />
      </div>
    </Wrapper>
  )
}

export { CollaboUpload }
